module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess7.d5b7959e.jpg";